export const config = {
    //apiUrl: 'http://127.0.0.1:8080'     // <-- à utiliser en local
    apiUrl: 'https://softball.cardonne.eu/api/'  // <-- à utiliser en prod sur le serveur
  };
  